interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "ALL";
};

const ALL: Currency = Object.freeze({
  "displayName": "Albania Lek",
  "numericCode": 8,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "ALL",
  "symbol": "L"
});

export { ALL };
